import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

export interface EmbedVideoEventAdapterParams {
  provider: 'youtube' | 'vimeo';
  start: number;
  end: number;
  duration: number;
}

type EmbedVideoEventData = {
  provider: 'youtube' | 'vimeo';
  start: number;
  end: number;
  duration: number;
};

export class EmbedVideoEventAdapter extends EventAdapter<EmbedVideoEventData> {
  protected intercomEventKey = EventTypes.EmbedVideo;

  constructor({
    provider,
    start,
    end,
    duration,
  }: EmbedVideoEventAdapterParams) {
    super();

    this.eventData = {
      provider,
      start,
      end,
      duration,
    };
  }
  protected amplitudeEventFunction = function embedVideoEvent(
    event: EmbedVideoEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.EmbedVideo, event);
  };
}
